import React from "react";
import { Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  setSelectedService,
  nextStep,
  previousStep,
  setStep,
} from "../../redux/reducers/stepSlice";
import { RootState } from "../../store";
import JunkRemovalDetails from "../junkRemovalDetails/JunkRemovalDetails";
import JunkRemovalType from "../junkRemovalType/JunkRemovalType";
import UserDetails from "../userDetails/UserDetails";
import Confirmation from "../junkRemovalConfirmation/confirmation";

const JunkRemovalCard = () => {
  const step = useSelector((state: RootState) => state.step.step);
  const selectedService = useSelector(
    (state: RootState) => state.step.selectedService
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { businessName } = useParams();

  const handleBack = () => {
    if (step === 1) {
      navigate(`/${businessName}/select-service`);
    } else {
      dispatch(previousStep());
    }
  };

  const handleNext = (canonicalId?: string) => {
    if (step === 1 && canonicalId) {
      navigate(`/${businessName}/junk-removal/${canonicalId}`);
      // dispatch(nextStep());
    }
    dispatch(nextStep());
  };

  return (
    <Box sx={{ width: "100%" }}>
      {step === 1 && (
        <JunkRemovalDetails
          onNext={handleNext}
          onBack={handleBack}
        />
      )}
      {step === 2 && (
        <JunkRemovalType onNext={handleNext} onBack={handleBack} />
      )}
      {/* {step === 3 && (
        <UserDetails onNext={handleNext} onBack={handleBack} currentValues="junk_removal"/>
      )} */}
      {step === 4 && (
        <Confirmation onNext={handleNext} onBack={handleBack} />
      )}
    </Box>
  );
};

export default JunkRemovalCard;